export default "__VITE_ASSET__Dx44jnCh__"